// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { ClientProfileMinimalGrantorRelationshipFragment } from '../../clientProfiles/graphql/ClientProfile.generated';
import { gql } from '@apollo/client';
import { ClientProfileMinimalGrantorRelationshipFragmentDoc } from '../../clientProfiles/graphql/ClientProfile.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateFamilyTreeRelationshipMutationVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
  clientRelationships?: Types.InputMaybe<Array<Types.UpdateClientProfileRelationship> | Types.UpdateClientProfileRelationship>;
}>;


export type UpdateFamilyTreeRelationshipMutation = { __typename?: 'Mutation', updateClientProfileRelationships: Array<(
    { __typename?: 'ClientProfileRelationship' }
    & ClientProfileMinimalGrantorRelationshipFragment
  ) | null> };

export const Operations = {
  Mutation: {
    UpdateFamilyTreeRelationship: 'UpdateFamilyTreeRelationship' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const UpdateFamilyTreeRelationshipDocument = gql`
    mutation UpdateFamilyTreeRelationship($householdId: ID!, $clientRelationships: [UpdateClientProfileRelationship!]) {
  updateClientProfileRelationships(
    householdId: $householdId
    updateRelationships: $clientRelationships
  ) {
    ...ClientProfileMinimalGrantorRelationship
  }
}
    ${ClientProfileMinimalGrantorRelationshipFragmentDoc}`;
export type UpdateFamilyTreeRelationshipMutationFn = Apollo.MutationFunction<UpdateFamilyTreeRelationshipMutation, UpdateFamilyTreeRelationshipMutationVariables>;

/**
 * __useUpdateFamilyTreeRelationshipMutation__
 *
 * To run a mutation, you first call `useUpdateFamilyTreeRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFamilyTreeRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFamilyTreeRelationshipMutation, { data, loading, error }] = useUpdateFamilyTreeRelationshipMutation({
 *   variables: {
 *      householdId: // value for 'householdId'
 *      clientRelationships: // value for 'clientRelationships'
 *   },
 * });
 */
export function useUpdateFamilyTreeRelationshipMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFamilyTreeRelationshipMutation, UpdateFamilyTreeRelationshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFamilyTreeRelationshipMutation, UpdateFamilyTreeRelationshipMutationVariables>(UpdateFamilyTreeRelationshipDocument, options);
      }
export type UpdateFamilyTreeRelationshipMutationHookResult = ReturnType<typeof useUpdateFamilyTreeRelationshipMutation>;
export type UpdateFamilyTreeRelationshipMutationResult = Apollo.MutationResult<UpdateFamilyTreeRelationshipMutation>;
export type UpdateFamilyTreeRelationshipMutationOptions = Apollo.BaseMutationOptions<UpdateFamilyTreeRelationshipMutation, UpdateFamilyTreeRelationshipMutationVariables>;